import { AUTHORIZATION_HEADER } from '../../../../../../../../src/authorization';
import { send } from '../../../../../../../../src/network';
import { type PlanComponentEditModel } from '../../../../../../../../src/types/PlanServicePlanComponents';
import { type UpdateCustomerPlanResponse } from '../../../../../../../../src/types/UpdateCustomerPlanResponse';

export type PutPlanServiceCustomerPlanFullEditRequestBody = {
  actor: string;
  plan_components: PlanComponentEditModel[];
};
export type PutPlanServiceCustomerPlanFullEditParams = {
  customerId: number;
  body: PutPlanServiceCustomerPlanFullEditRequestBody;
  commit?: 0 | 1;
};

export function updatePlanServiceCustomerPlanFullEditPath({
  customerId,
  commit,
}: Pick<PutPlanServiceCustomerPlanFullEditParams, 'customerId' | 'commit'>) {
  return `/api/v2/plan_service/customers/${customerId}/plans/full_edit/${
    commit !== undefined ? `?commit=${commit}` : ''
  }`;
}

export async function updatePlanServiceCustomerPlanFullEdit({
  customerId,
  body,
  commit,
}: PutPlanServiceCustomerPlanFullEditParams) {
  return await send<UpdateCustomerPlanResponse>({
    path: updatePlanServiceCustomerPlanFullEditPath({ customerId, commit }),
    method: 'PUT',
    body,
    headers: new Headers({
      AUTHORIZATION: AUTHORIZATION_HEADER,
    }),
  });
}
